/** Formula to validate package */

export default function validateSelectedPackage(
  currentPackage: string | undefined,
): number {
  const value = Number(currentPackage);
  if ([1, 2, 3].includes(value)) {
    return value;
  }
  return 0;
}
